import { createRouter, createWebHistory } from 'vue-router'
import QueueTelatv from '../components/pages/QueueTelatv.vue'
import QueueWork from '../components/pages/QueueWork.vue'
import QueueCleint from '../components/pages/QueueCleint.vue'
import QueueAccount from '../components/pages/QueueAccount.vue'

const routes = [
  {
    path: '/account',
    name: 'QueueAccount',
    component: QueueAccount
  },
  {
    path: '/:account/work',
    name: 'QueueWork',
    component: QueueWork
  },
  {
    path: '/:account/:station/:number',
    name: 'QueueCleint',
    component: QueueCleint
  },
  {
    path: '/:account/:station',
    name: 'QueueTelatv',
    component: QueueTelatv
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
